import React from "react";
import PrintSafesMain from "../PrintSafesMain";

export default function RevGardUnitts(props) {
    const {dataPrint,closePrint ,infoPrint}=props

    return (
        <div>
            <PrintSafesMain  typePrint={2} docNamePdf={"RevewJard.pdf"} docName={"RevewJard"}
            dataPrint={dataPrint} closePrint={closePrint}/>
        </div>
    );
}

